import * as React from "react";

import { cn } from "../../lib/utils";
import { Input } from "./input";

interface SearchInputProps extends React.ComponentProps<"input"> {
  containerClassName?: string;
}

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, containerClassName, ...props }, ref) => (
    <div className={cn("relative", containerClassName)}>
      <i
        className="fa-regular fa-magnifying-glass pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs text-neutral-500"
        aria-hidden="true"
      />
      <Input
        ref={ref}
        type="search"
        className={cn("h-9 pl-8 font-inter", className)}
        {...props}
      />
    </div>
  )
);
SearchInput.displayName = "SearchInput";

export { SearchInput };
